<template>
	<!--
		Schede delle sezioni Amazon ed eBay (al posto del vecchio menu "Catalogo"): ogni scheda e' una pagina
		con il suo URL. Va nello slot extension della v-toolbar della pagina.
	-->
	<v-tabs show-arrows data-tour="tabs">
		<v-tab v-for="tab in tabs" :key="tab.path" :to="tab.path" :exact="tab.exact" :data-tour="`tab-${tab.key}`">
			<v-icon small left>{{ tab.icon }}</v-icon>
			{{ tab.text }}
		</v-tab>
	</v-tabs>
</template>

<script>
// piattaforma -> radice delle route (/amazon, /ebay)
const TABS = [
	{ key: 'listings', path: '', text: 'Inserzioni', icon: 'mdi-format-list-bulleted', exact: true },
	{ key: 'unmatched', path: '/associa', text: 'Associa prodotti', icon: 'mdi-link-variant' },
	{ key: 'price-analysis', path: '/analisi-prezzi', text: 'Analisi prezzi', icon: 'mdi-chart-line' },
	{ key: 'rules', path: '/regole', text: 'Regole feed', icon: 'mdi-tune-variant' },
	{ key: 'repricing', path: '/repricing', text: 'Repricing', icon: 'mdi-lightning-bolt-outline' },
];

export default {
	name: 'MarketplaceTabs',
	props: {
		// 'amazon' | 'ebay'
		platform: { type: String, required: true },
	},
	computed: {
		tabs() {
			return TABS.map(t => ({ ...t, path: `/${this.platform}${t.path}` }));
		},
	},
};
</script>
